// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__31kfL","resendInfoText":"OnGoingPaymentBox_resendInfoText__1ZpJ5"};